import * as v from 'valibot';
export const FilterSchema = v.record(v.string());

export type TFilter = v.Output<typeof FilterSchema>;
